export const EXPAND_MS = 200, COLLAPSE_MS = 160;
const running = new WeakMap();
// Animate the real row height. An auto-height mobile sheet follows the same layout on every frame.
export function animateDisclosure(rows, open) {
  const previous = running.get(rows);
  const from = rows.hidden ? 0 : rows.getBoundingClientRect?.().height ?? 0;
  previous?.cancel(); running.delete(rows);
  if (!rows.animate || globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches) { rows.hidden = !open; return; }
  rows.hidden = false;
  const to = open ? rows.getBoundingClientRect().height : 0;
  const css = getComputedStyle(rows), margin = css.marginTop, border = css.borderTopWidth;
  const animation = rows.animate([{height: from + 'px', marginTop: previous ? css.marginTop : open ? '0px' : margin, borderTopWidth: open ? '0px' : border, overflow: 'clip', minHeight: '0'},
      {height: to + 'px', marginTop: open ? margin : '0px', borderTopWidth: open ? border : '0px', overflow: 'clip', minHeight: '0'}],
    {duration: open ? EXPAND_MS : COLLAPSE_MS, easing: open ? 'ease-out' : 'ease-in'});
  running.set(rows, animation);
  animation.onfinish = () => { if (running.get(rows) !== animation) return; rows.hidden = !open; running.delete(rows); };
}
